import { ObjectDb } from './object.db';
import { OrganizationGridItemObject, ServiceGridItemObject } from '@it2go/types';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class OrganizationSettingDb extends ObjectDb<OrganizationGridItemObject> {

    public tableName = 'organizationSettings';

    protected override columnMap = {
        organizationId: 'organizationId',
    };

    protected gqlMethod = 'getOrganizationSettings';

    protected syncFragment = `
        id
        organizationId
        key
        data
        active
        createdAt
        updatedAt
    `;

}
